import Chip from "./Chip";

export default function ChipList({ values }) {
  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-wrap gap-2">
        {values.map((item, index) => (
          <Chip key={index} label={item.label} />
        ))}
      </div>
    </div>
  );
}
